import styled from 'styled-components';

export const PredictionsWrapper = styled.div`
  padding: 10px 5%;
  background-color: aliceblue;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    padding: 16px 5%;
  }
`;

export const StatsBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
`;

export const StatsContentWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 30px;
  padding: 10px 20px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  background-color: #f9f9f9;
  margin-bottom: 20px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
`;

export const AcceptAllButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
`;

export const FrameImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  object-fit: contain;
  z-index: 1;
`;

export const CoverWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: black;
  width: 100%;
  height: 300px;
`;

export const PixelTracker = styled.div`
  position: absolute;
  inset: 0;
  z-index: 3;
  pointer-events: auto;
`;

export const HoverSvg = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  pointer-events: auto;
`;

export const TooltipBox = styled.div`
  position: absolute;
  transform: translate(-50%, -100%);
  z-index: 4;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  padding: 4px 8px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
  display: flex;
  align-items: center;
`;

export const TooltipBadge = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin-right: 6px;
`;
